import { shouldPublish } from "src/utils/publishUtils";
import { promotionCategoryMatchesRoute } from "src/utils/promotionCategory";

const sameIdentity = (a, b) => a != null && b != null && String(a) === String(b);

/**
 * Filters promotion hub cards by publish window and optional category route slug.
 *
 * @param {import('src/utils/mapPromotion').PromotionCard[]} cards
 * @param {string} [routeCategory] - `params.category` from react-router (EN or FR URL segment)
 * @param {{ livePreviewId?: string|number }} [options]
 * @returns {import('src/utils/mapPromotion').PromotionCard[]}
 */
export function filterPromotionCards(cards, routeCategory, options = {}) {
  const { livePreviewId } = options;
  if (!Array.isArray(cards)) return [];

  return cards.filter((card) => {
    const isLiveCard =
      livePreviewId != null &&
      (sameIdentity(card.id, livePreviewId) || sameIdentity(card.key, livePreviewId));
    if (!isLiveCard && !shouldPublish(card)) return false;

    if (routeCategory) {
      return promotionCategoryMatchesRoute(routeCategory, card.category);
    }

    return true;
  });
}
